import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {NotFoundComponent} from './components/not-found/not-found.component';
import {RoutesEnums} from './enums/RoutesEnums';

const routes: Routes = [
  {
    path: RoutesEnums.SEARCH,
    loadChildren: () => import('./modules/search/search.module').then((m) => m.SearchModule),
    // resolve: {searchData: SearchDataResolver},
  },
  {
    path: RoutesEnums.GUIDE,
    loadChildren: () => import('./modules/guide/guide.module').then((m) => m.GuideModule),
  },
  {
    path: RoutesEnums.BLOG,
    loadChildren: () => import('./modules/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: RoutesEnums.FOR_CAREPROVIDERS,
    loadChildren: () =>
      import('./modules/for-careproviders/for-careproviders.module').then((m) => m.ForCareprovidersModule),
  },
  {
    path: RoutesEnums.NATIVES,
    loadChildren: () => import('./modules/natives/natives.module').then((m) => m.NativesModule),
  },
  {
    path: RoutesEnums.WEBVIEW,
    loadChildren: () => import('./modules/webview/webview.module').then((m) => m.WebviewModule),
  },
  {
    path: RoutesEnums.CAREPROVIDER,
    loadChildren: () =>
      import('./modules/careprovider-unit/careproviders-unit.module').then((m) => m.CareprovidersUnitModule),
  },
  {
    path: RoutesEnums.CARESERVICE,
    loadChildren: () => import('./modules/care-service/care-service.module').then((m) => m.CareServiceModule),
  },
  {
    path: RoutesEnums.PAGE,
    loadChildren: () => import('./modules/page/page.module').then((m) => m.PageModule),
  },
  {
    path: RoutesEnums.AUTHOR,
    loadChildren: () => import('./modules/author/author.module').then((m) => m.AuthorModule),
  },
  {
    path: RoutesEnums.BOOKING,
    loadChildren: () => import('./modules/booking-v2/booking-v2.module').then((m) => m.BookingV2Module),
  },
  {
    path: RoutesEnums.CAMPAIGN,
    loadChildren: () => import('./modules/campaign/campaign.module').then((m) => m.CampaignModule),
  },
  // {
  //   path: RoutesEnums.SITEOVERVIEW,
  //   loadChildren: () => import('./modules/site-overview/site-overview.module').then((m) => m.SiteOverviewModule),
  // },
  {
    path: RoutesEnums.MYPAGES,
    loadChildren: () => import('./modules/my-pages/my-pages.module').then((m) => m.MyPagesModule),
  },
  {
    path: RoutesEnums.RELATED,
    loadChildren: () => import('./modules/related/related.module').then((m) => m.RelatedModule),
  },
  // {
  //   path: RoutesEnums.EMPTY_W_H,
  //   loadChildren: () => import('./modules/emptywh/emptywh.module').then((m) => m.EmptywhModule),
  // },
  // {
  //   path: RoutesEnums.EMPTY,
  //   loadChildren: () => import('./modules/empty/empty.module').then((m) => m.EmptyModule),
  // },
  {path: RoutesEnums.NOTFOUND, component: NotFoundComponent},
  {
    path: RoutesEnums.HOME,
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: '**',
    loadChildren: () => import('./modules/redirects/redirects.module').then((m) => m.RedirectsModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'disabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'ignore',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
